import { Box, Checkbox, CircularProgress, Container, FormControlLabel, Grid, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react'
import { Redirect } from 'react-router-dom/cjs/react-router-dom';
import Constantes from '../php/Constantes';


const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 12,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const handleDownloadPdf = (name, data) => {
    const blobData = atob(data);
    const byteArray = new Uint8Array(blobData.length);
    for (let i = 0; i < blobData.length; i++) {
      byteArray[i] = blobData.charCodeAt(i);
    }
    const fileBlob = new Blob([byteArray], { type: 'application/pdf' });
    const fileUrl = URL.createObjectURL(fileBlob);

    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

class ConsultaRetroactivo extends Component {
    constructor(props){
        super(props);
        this.state = {
            errores: null,
            notificaciones: null,
            loading: false,
            datosConsulta: [],
            todos: [],

            listFuncionarios: {
                todos: true,
                pendientes: false,
                enviados: false,
                aceptados: false,
                rechazados: false,
                noFirma: false,
            },

            datoEspecifico: {},
            modalMostrar: false,

        }
        this.manejarEnviarAceptar = this.manejarEnviarAceptar.bind(this);
        this.funcionariosListar = this.funcionariosListar.bind(this);
        this.manejarEnviarRechazar = this.manejarEnviarRechazar.bind(this);
        this.manejarRechazar = this.manejarRechazar.bind(this);
        this.manejarCambiosDatosRechazar = this.manejarCambiosDatosRechazar.bind(this);
        this.manejarCerrarModal = this.manejarCerrarModal.bind(this);
        this.manejarPedirPDF = this.manejarPedirPDF.bind(this);
    }

    async componentDidMount(){
        const consulta = await fetch(`${Constantes.RUTA_API}/obtener_retroactivoFuncionarios.php`);
        const datoConsulta = await consulta.json();
        this.setState({
            datosConsulta: datoConsulta[1],
            todos: datoConsulta[1],
        });
    }

    render(){
        return (
            <>
                {sessionStorage.login
                ?
                    null
                :
                    <Redirect to='/calmette-app/login'/>
                }
                {this.state.loading
                ?
                    <div style={{placeItems: 'center'}}>
                        <Box sx={{alignItems: 'center'}}>
                            <CircularProgress/>
                        </Box>
                    </div>
                :
                    null
                }
                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                <Container>
                    <FormControlLabel label='TODOS' control={<Checkbox checked={this.state.listFuncionarios.todos} onChange={this.funcionariosListar} id='todos'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                    <FormControlLabel label='PENDIENTES' control={<Checkbox checked={this.state.listFuncionarios.pendientes} onChange={this.funcionariosListar} id='pendientes'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                    <FormControlLabel label='ENVIADOS' control={<Checkbox checked={this.state.listFuncionarios.enviados} onChange={this.funcionariosListar} id='enviados'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                    <FormControlLabel label='ACEPTADOS' control={<Checkbox checked={this.state.listFuncionarios.aceptados} onChange={this.funcionariosListar} id='aceptados'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                    <FormControlLabel label='RECHAZADOS' control={<Checkbox checked={this.state.listFuncionarios.rechazados} onChange={this.funcionariosListar} id='rechazados'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                    <FormControlLabel label='NO FIRMA' control={<Checkbox checked={this.state.listFuncionarios.noFirma} onChange={this.funcionariosListar} id='noFirma'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                    <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto', marginTop: '1rem'}} component={Paper}>
                        <Table sx={{minWidth: 700}}>
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell style={{textAlign: 'center'}}>Número Funcionario</StyledTableCell>
                                    <StyledTableCell style={{textAlign: 'center'}}>Nombre</StyledTableCell>
                                    <StyledTableCell style={{textAlign: 'center'}}>Estado</StyledTableCell>
                                    <StyledTableCell style={{textAlign: 'center'}}>Acuerdo</StyledTableCell>
                                    <StyledTableCell style={{textAlign: 'center'}}></StyledTableCell>
                                    <StyledTableCell style={{textAlign: 'center'}}></StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.datosConsulta.map((name, index) => (
                                    <StyledTableRow key={index}>
                                        <StyledTableCell style={{textAlign: 'center'}}>{name.numeroFuncionario}</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{name.nombre}</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{name.estado}</StyledTableCell>
                                        {name.cargoPDF ? <StyledTableCell style={{textAlign: 'center'}}><button className="btn btn-outline-primary btn-sm mx-2" onClick={() => this.manejarPedirPDF(name.idRetroactivo)}>Descargar</button></StyledTableCell> : <StyledTableCell></StyledTableCell>}
                                        {name.estadoCodigo === 1 ? <StyledTableCell style={{textAlign: 'center'}}><button className="btn btn-outline-primary btn-sm mx-2" type='button' onClick={() => this.manejarEnviarAceptar(name)}>Aceptar</button></StyledTableCell> : <StyledTableCell></StyledTableCell>}
                                        {name.estadoCodigo === 1 ? <StyledTableCell style={{textAlign: 'center'}}><button className="btn btn-outline-primary btn-sm mx-2" type='button' onClick={() => this.manejarRechazar(name)}>Rechazar</button></StyledTableCell> : <StyledTableCell></StyledTableCell>}
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Container>
                {this.state.modalMostrar
                ?
                    <Modal open={this.state.modalMostrar}>
                        <Box sx={styleModal} >
                            <Grid container spacing={2} rowSpacing={1}>
                                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                                <Grid item xs={4}>
                                </Grid>
                                <Grid item xs={4}>
                                    <Item>Motivo Rechazo</Item>
                                </Grid>
                                <textarea style={{width:"100%", border:"2px solid #D6EAF8", marginTop: '1rem'}} id='motivoRechazo' value={this.state.datoEspecifico.motivoRechazo} onChange={this.manejarCambiosDatosRechazar}/>
                                <Grid item xs={4}>
                                </Grid>
                                <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarCerrarModal}>Cerrar</button>
                                <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnviarRechazar}>Enviar</button>
                            </Grid>
                        </Box>
                    </Modal>
                :
                    null
                }
            </>
        )
    }

    async manejarEnviarAceptar(dato){
        const confirmacion = window.confirm('¿Confirmar aceptar acuerdo?');

        if (confirmacion) {
            this.setState({
                loading: true,
            });
            const cargaUtil = JSON.stringify([dato]);
    
            const control = await fetch(`${Constantes.RUTA_API}/enviar_aceptarAcuerdo.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();
    
            this.setState({
                loading: false,
                errores: res[0],
                notificaciones: null,
            })
    
            if(res[0] === 'ok'){
                this.setState({
                    loading: true,
                    errores: null,
                    notificaciones: 'Datos ingresados correctamente',
                })

                const consulta = await fetch(`${Constantes.RUTA_API}/obtener_retroactivoFuncionarios.php`);
                const datoConsulta = await consulta.json();
                this.setState({
                    loading: false,
                    datosConsulta: datoConsulta[1],
                    todos: datoConsulta[1],

                    listFuncionarios: {
                        todos: true,
                        pendientes: false,
                        enviados: false,
                        aceptados: false,
                        rechazados: false,
                        noFirma: false,
                    },
                });
            }
        }
    }

    funcionariosListar(e){
        const clave = e.target.id;
        this.setState({
            notificaciones: null,
            errores: null,
            loading: false,
        })
        if(clave === 'todos'){
            this.setState({
                listFuncionarios: {
                    todos: true,
                    pendientes: false,
                    enviados: false,
                    aceptados: false,
                    rechazados: false,
                    noFirma: false,
                },
            });
            this.setState(prevState => ({
                datosConsulta: prevState.todos.filter(todos => todos.estadoCodigo !== '')
            }));
        }else if(clave === 'pendientes'){
            this.setState({
                listFuncionarios: {
                    todos: false,
                    pendientes: true,
                    enviados: false,
                    aceptados: false,
                    rechazados: false,
                    noFirma: false,
                },
            })
            this.setState(prevState => ({
                datosConsulta: prevState.todos.filter(todos => todos.estadoCodigo === 0)
            }));
        }else if(clave === 'enviados'){
            this.setState({
                listFuncionarios: {
                    todos: false,
                    pendientes: false,
                    enviados: true,
                    aceptados: false,
                    rechazados: false,
                    noFirma: false,
                },
            })
            this.setState(prevState => ({
                datosConsulta: prevState.todos.filter(todos => todos.estadoCodigo === 1)
            }));
        }else if(clave === 'aceptados'){
            this.setState({
                listFuncionarios: {
                    todos: false,
                    pendientes: false,
                    enviados: false,
                    aceptados: true,
                    rechazados: false,
                    noFirma: false,
                },
            })
            this.setState(prevState => ({
                datosConsulta: prevState.todos.filter(todos => todos.estadoCodigo === 2)
            }));
        }else if(clave === 'rechazados'){
            this.setState({
                listFuncionarios: {
                    todos: false,
                    pendientes: false,
                    enviados: false,
                    aceptados: false,
                    rechazados: true,
                    noFirma: false,
                },
            })
            this.setState(prevState => ({
                datosConsulta: prevState.todos.filter(todos => todos.estadoCodigo === 3)
            }));
        }else if(clave === 'noFirma'){
            this.setState({
                listFuncionarios: {
                    todos: false,
                    pendientes: false,
                    enviados: false,
                    aceptados: false,
                    rechazados: false,
                    noFirma: true,
                },
            })
            this.setState(prevState => ({
                datosConsulta: prevState.todos.filter(todos => todos.estadoCodigo === 4)
            }));
        }
    }

    manejarRechazar(dato){
        this.setState({
            modalMostrar: true,
            datoEspecifico: dato,
        })
    }

    async manejarEnviarRechazar(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            loading: false,
        });

        if((this.state.datoEspecifico.motivoRechazo === '')){
            this.setState({
                errores: 'Error - Debe ingresar el motivo del rechazo.',
            });
        }else{
            this.setState({
                loading: true,
            });
            const cargaUtil = JSON.stringify([this.state.datoEspecifico]);
    
            const control = await fetch(`${Constantes.RUTA_API}/enviar_rechazarAcuerdo.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();
    
            this.setState({
                loading: false,
                errores: res[0],
                notificaciones: null,
            })
    
            if(res[0] === 'ok'){
                this.setState({
                    loading: true,
                    errores: null,
                    notificaciones: 'Datos ingresados correctamente',
                    modalMostrar: false,
                    datoEspecifico: {},
                })

                const consulta = await fetch(`${Constantes.RUTA_API}/obtener_retroactivoFuncionarios.php`);
                const datoConsulta = await consulta.json();
                this.setState({
                    loading: false,
                    datosConsulta: datoConsulta[1],
                    todos: datoConsulta[1],

                    listFuncionarios: {
                        todos: true,
                        pendientes: false,
                        enviados: false,
                        aceptados: false,
                        rechazados: false,
                        noFirma: false,
                    },
                });
            }
        }
    }

    manejarCambiosDatosRechazar(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const movimientosActualizado = state.datoEspecifico;
            movimientosActualizado[clave] = valor;
            return{
                datoEspecifico: movimientosActualizado,
            };
        })
    }

    manejarCerrarModal(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            modalMostrar: false,
        })
    }

    async manejarPedirPDF(idRetroactivo){
        this.setState({
            loading: true,
        });
        const cargaUtil = JSON.stringify([idRetroactivo]);

        const control = await fetch(`${Constantes.RUTA_API}/obtener_pdfRetroactivo.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await control.json();

        this.setState({
            loading: false,
            errores: res[0],
            notificaciones: null,
        })

        if(res[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: null,
            })
            //handleDownloadPdf = ('acuerdo', res[1].acuerdo);
            //--------------------------------------
            const name = 'acuerdo';
            const data = res[1].acuerdo;
            const blobData = atob(data);
            const byteArray = new Uint8Array(blobData.length);
            for (let i = 0; i < blobData.length; i++) {
            byteArray[i] = blobData.charCodeAt(i);
            }
            const fileBlob = new Blob([byteArray], { type: 'application/pdf' });
            const fileUrl = URL.createObjectURL(fileBlob);

            const link = document.createElement('a');
            link.href = fileUrl;
            link.download = name;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            //--------------------------------------
        }
        //handleDownloadPdf = (name, data);
    }
}

export default ConsultaRetroactivo